import { memo } from 'react'
import { baseInputClasses, labelClasses, getSelectClasses, getTextareaClasses } from '../../styles/inputStyles'

/**
 * AnnouncementFormFields - Main form fields for announcement
 * Includes title, content, language, type, priority, and translation group
 */
const AnnouncementFormFields = memo(function AnnouncementFormFields({
  formData,
  onChange
}) {
  return (
    <>
      <div>
        <label htmlFor="title" className={labelClasses}>
          Title *
        </label>
        <input
          type="text"
          id="title"
          name="title"
          value={formData.title}
          onChange={onChange}
          required
          className={baseInputClasses}
        />
      </div>

      <div>
        <label htmlFor="content" className={labelClasses}>
          Content *
        </label>
        <textarea
          id="content"
          name="content"
          value={formData.content}
          onChange={onChange}
          required
          rows={6}
          className={getTextareaClasses()}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="language" className={labelClasses}>
            Language *
          </label>
          <select
            id="language"
            name="language"
            value={formData.language}
            onChange={onChange}
            required
            className={getSelectClasses()}
          >
            <option value="en">English</option>
            <option value="es-MX">Spanish (Mexico)</option>
            <option value="fr-CA">French (Canada)</option>
            <option value="pt-BR">Portuguese (Brazil)</option>
            <option value="ru">Russian</option>
            <option value="zh-CN">Chinese (Simplified)</option>
          </select>
        </div>

        <div>
          <label htmlFor="announcementType" className={labelClasses}>
            Type *
          </label>
          <select
            id="announcementType"
            name="announcementType"
            value={formData.announcementType}
            onChange={onChange}
            required
            className={getSelectClasses()}
          >
            <option value="general">General</option>
            <option value="update">Update</option>
            <option value="event">Event</option>
            <option value="maintenance">Maintenance</option>
            <option value="feature">Feature</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="priority" className={labelClasses}>
            Priority *
          </label>
          <select
            id="priority"
            name="priority"
            value={formData.priority}
            onChange={onChange}
            required
            className={getSelectClasses()}
          >
            <option value="low">Low</option>
            <option value="normal">Normal</option>
            <option value="high">High</option>
            <option value="urgent">Urgent</option>
          </select>
        </div>

        <div>
          <label htmlFor="translationGroupId" className={labelClasses}>
            Translation Group ID (Optional)
          </label>
          <input
            type="text"
            id="translationGroupId"
            name="translationGroupId"
            value={formData.translationGroupId}
            onChange={onChange}
            placeholder="Leave empty for standalone announcement"
            className={baseInputClasses}
          />
          <p className="text-xs text-gray-500 mt-1">
            To link translations: Use same ID for all languages. Generate with: <code className="bg-gray-100 px-1">uuidgen</code>
          </p>
        </div>
      </div>
    </>
  )
})

export default AnnouncementFormFields
